var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailedAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EBF0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 22.7148C19.7167 22.7148 19.4792 22.6207 19.2875 22.4324C19.0958 22.2442 19 22.0109 19 21.7326V16.8218C19 16.5435 19.0958 16.3102 19.2875 16.122C19.4792 15.9337 19.7167 15.8396 20 15.8396H22C22.2833 15.8396 22.5208 15.9337 22.7125 16.122C22.9042 16.3102 23 16.5435 23 16.8218V21.7326C23 22.0109 22.9042 22.2442 22.7125 22.4324C22.5208 22.6207 22.2833 22.7148 22 22.7148H20ZM14 22.7148C13.7167 22.7148 13.4792 22.6207 13.2875 22.4324C13.0958 22.2442 13 22.0109 13 21.7326V7.98218C13 7.70389 13.0958 7.47063 13.2875 7.28238C13.4792 7.09413 13.7167 7 14 7H16C16.2833 7 16.5208 7.09413 16.7125 7.28238C16.9042 7.47063 17 7.70389 17 7.98218V21.7326C17 22.0109 16.9042 22.2442 16.7125 22.4324C16.5208 22.6207 16.2833 22.7148 16 22.7148H14ZM8 22.7148C7.71667 22.7148 7.47917 22.6207 7.2875 22.4324C7.09583 22.2442 7 22.0109 7 21.7326V12.8931C7 12.6148 7.09583 12.3815 7.2875 12.1933C7.47917 12.005 7.71667 11.9109 8 11.9109H10C10.2833 11.9109 10.5208 12.005 10.7125 12.1933C10.9042 12.3815 11 12.6148 11 12.8931V21.7326C11 22.0109 10.9042 22.2442 10.7125 22.4324C10.5208 22.6207 10.2833 22.7148 10 22.7148H8Z",
    fill: "#1B58F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedAnalysis);
export default __webpack_public_path__ + "static/media/detailed_analysis.de8f5cc7067c1c2e9503f53e115f1892.svg";
export { ForwardRef as ReactComponent };